module.exports = __webpack_public_path__ + "media/landing_page/hero-mobile-1-a92c9409.webp";